export const SET_STEP = 'SET_STEP';

export const TOGGLE_AUDIO = 'TOGGLE_AUDIO';

export const EXPLODE_SNOWFLAKES = 'EXPLODE_SNOWFLAKES';

export const SET_TIMELINE_VISIBILITY = 'SET_TIMELINE_VISIBILITY';

export const SHUFFLE_QUOTES = 'SHUFFLE_QUOTES';

export const SET_THEME = 'SET_THEME';
export const SHUFFLE_THEMES = 'SHUFFLE_THEMES';



/** WEBPACK FOOTER **
 ** ./src/js/constants/actions.js
 **/